import en from './translations/en';
import fr from './translations/fr';

export const translations = {
  en,
  fr
};

export const userPrefix = [
  { value: 'Ms', label: 'Ms.' },
  { value: 'Mr', label: 'Mr.' },
  { value: 'Mrs', label: 'Mrs.' },
  { value: 'Dr', label: 'Dr.' },
  { value: 'Rev', label: 'Rev.' },
  { value: 'Bro', label: 'Bro.' },
  { value: 'Sis', label: 'Sis.' }
]

export const EVENT_TYPES = [
  'Memorial',
  'Public Lecture',
  'Bible Class',
  'Sunday School',
  'Junior CYC & Little Disciples',
  'Hall Duties',
  'Senior CYC'
];

export const COLLECTION_TYPES = ['REG', 'BLDG', 'CBMC', 'CHC'];